import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { EyeIcon, EyeOffIcon, TruckIcon } from 'lucide-react';
interface LoginProps {
  onLogin: () => void;
}
const Login: React.FC<LoginProps> = ({
  onLogin
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    // Simulate API call
    setTimeout(() => {
      // For demo purposes, accept any non-empty email/password
      if (email && password) {
        onLogin();
      } else {
        setError('Please enter both email and password.');
      }
      setLoading(false);
    }, 1000);
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-696">
      <div className="max-w-md w-full space-y-8" data-id="element-697">
        <div data-id="element-698">
          <div className="mx-auto h-26 w-auto flex items-center justify-center" data-id="element-699">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qrpHAAKgkN1H9JhJ8LpouX/ThePoint_LogoMark_RGB_Final.png" alt="The Point TMS" className="h-[175px] w-auto" data-id="element-700" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-701">
            Sign in to your account
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600" data-id="element-702">
            Or{' '}
            <Link to="/register" className="font-medium text-primary-700 hover:text-primary-800" data-id="element-703">
              register for a new account
            </Link>
          </p>
        </div>
        {error && <div className="bg-red-50 border-l-4 border-red-500 p-4" data-id="element-704">
            <p className="text-sm text-red-700" data-id="element-705">{error}</p>
          </div>}
        <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-706">
          <div className="rounded-md shadow-sm -space-y-px" data-id="element-707">
            <div data-id="element-708">
              <label htmlFor="email-address" className="sr-only" data-id="element-709">
                Email address
              </label>
              <input id="email-address" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm" placeholder="Email address" data-id="element-710" />
            </div>
            <div className="relative" data-id="element-711">
              <label htmlFor="password" className="sr-only" data-id="element-712">
                Password
              </label>
              <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm" placeholder="Password" data-id="element-713" />
              <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-714">
                {showPassword ? <EyeOffIcon className="h-5 w-5 text-gray-400" data-id="element-715" /> : <EyeIcon className="h-5 w-5 text-gray-400" data-id="element-716" />}
              </button>
            </div>
          </div>
          <div className="flex items-center justify-between" data-id="element-717">
            <div className="flex items-center" data-id="element-718">
              <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded" data-id="element-719" />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900" data-id="element-720">
                Remember me
              </label>
            </div>
            <div className="text-sm" data-id="element-721">
              <Link to="/reset-password" className="font-medium text-primary-700 hover:text-primary-800" data-id="element-722">
                Forgot your password?
              </Link>
            </div>
          </div>
          <div data-id="element-723">
            <button type="submit" disabled={loading} className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-700 hover:bg-primary-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:bg-primary-300" data-id="element-724">
              {loading ? <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-725">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-726"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-727"></path>
                </svg> : 'Sign in'}
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default Login;